import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = () => {
  const isLoggedIn = JSON.parse(sessionStorage.getItem("user_details")) || true;
  return isLoggedIn ? <Outlet /> : "";
};

export default PrivateRoutes;
